import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'

export const ANSWER_OPEN_ENDED_CREATE = 'ANSWER_OPEN_ENDED_CREATE'
export const ANSWER_OPEN_ENDED_CREATE_SUCCESS =
  'ANSWER_OPEN_ENDED_CREATE_SUCCESS'

export const Actions = {
  answerOpenEndedCreateSuccess: () =>
    createAction(ANSWER_OPEN_ENDED_CREATE_SUCCESS),
}

export type Actions = ActionsUnion<typeof Actions>
